module.exports = __webpack_public_path__ + "static/media/1013128.32f45f4d.png";